import { render, staticRenderFns } from "./ResultsPreview.vue?vue&type=template&id=046a94c0&"
import script from "./ResultsPreview.vue?vue&type=script&lang=ts&"
export * from "./ResultsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports